import { render } from "./NoProvider.vue?vue&type=template&id=f2c533e6"
import script from "./NoProvider.vue?vue&type=script&lang=js"
export * from "./NoProvider.vue?vue&type=script&lang=js"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__